<template>
	<vx-card :title='$t("WorkTypes")'>
		<vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="work_types">

			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<div class="flex flex-wrap-reverse items-center">
					<vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addWorkTypePrompt = true">{{$t("Add")}}</vs-button>
				</div>

				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ work_types.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : work_types.length }} of {{ work_types.length }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>

						<vs-dropdown-item @click="itemsPerPage=10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=20">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=50">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=100">
							<span>100</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="name">{{$t("Name")}}</vs-th>
				<vs-th sort-key="price">{{$t("Price")}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
				<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

					<vs-td :data="data[index].name">
						{{ data[index].name }}
					</vs-td>

					<vs-td :data="data[index].price">
						{{ data[index].price }}
					</vs-td>

				</vs-tr>
				</tbody>
			</template>

		</vs-table>

		<vs-popup :title="$t('Add')" :active.sync="addWorkTypePrompt">
			<div>
				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="addName" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("Price")}}</p>
				<vs-input v-model="addPrice" style="width: 100%"></vs-input>
				<vs-divider/>
				<vs-button color="success" type="border" class="mt-6; mr-1" @click="addWorkType">{{$t("Add")}}</vs-button>
			</div>
		</vs-popup>

		<vs-popup :title="$t('Edit')" :active.sync="editWorkTypePrompt">
			<div>
				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="editName" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("Price")}}</p>
				<vs-input v-model="editPrice" style="width: 100%"></vs-input>
				<vs-divider/>
				<vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editWorkType">{{$t("Change")}}</vs-button>
				<vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeWorkType">{{$t("Delete")}}</vs-button>
			</div>
		</vs-popup>
	</vx-card>
</template>
<script>

	export default {
		data() {
			return {
				selected: {},
				work_types: [],

				itemsPerPage: 20,
				isMounted: false,

				addWorkTypePrompt: false,
				editWorkTypePrompt: false,

				addName: '',
				addPrice: '',

				editName: '',
				editPrice: '',
			}
		},
		computed: {
			currentPage() {
				if(this.isMounted) {
					return this.$refs.table.currentx
				}
				return 0
			},
		},
		methods: {
			handleSelected(tr) {
				this.editName = tr.name;
				this.editPrice = tr.price;
				this.editWorkTypePrompt = true;
			},
			updateWorkTypes() {
				const thisIns = this;
				this.$http.get('/api/v1/work_type/')
						.then(function (response) {
							thisIns.work_types = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			addWorkType() {
				const thisIns = this;
				this.$http.post('/api/v1/work_type/', {
					name: thisIns.addName,
					price: Number(thisIns.addPrice),
				}).then(function () {
					thisIns.updateWorkTypes();
					thisIns.addWorkTypePrompt = false;
					thisIns.addName = "";
					thisIns.addPrice = "";
				}).catch(function (error) {
					thisIns.addWorkTypePrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			editWorkType() {
				const thisIns = this;
				this.$http.put('/api/v1/work_type/' + this.selected.id, {
					name: thisIns.editName,
					price: Number(thisIns.editPrice),
				}).then(function () {
					thisIns.updateWorkTypes();
					thisIns.editWorkTypePrompt = false;
				}).catch(function (error) {
					thisIns.editWorkTypePrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			removeWorkType() {
				const thisIns = this;
				this.$http.delete('/api/v1/work_type/' + this.selected.id)
						.then(function () {
							thisIns.updateWorkTypes();
							thisIns.editWorkTypePrompt = false;
						}).catch(function (error) {
					thisIns.editWorkTypePrompt = false;
					thisIns.$vs.notify({
						title: 'Error',
						text: error.response.data,
						color: 'danger',
						iconPack: 'feather',
						icon: 'icon-alert-circle'
					})
				});
			}
		},
		watch: {
			editWorkTypePrompt: function () {
				if(!this.editWorkTypePrompt){
					this.selected = {}
				}
			}
		},
		created() {
			this.updateWorkTypes()
		},
		mounted() {
			this.isMounted = true;
		},
		beforeRouteLeave (to, from, next) {
			if(this.addWorkTypePrompt){
				this.addWorkTypePrompt = false;
				next(false)
			}else if(this.editWorkTypePrompt){
				this.editWorkTypePrompt = false;
				next(false)
			}else{
				next()
			}
		}
	}
</script>
